
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connect/[...all]",
      function () {
        return require("private-next-pages/connect/[...all].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connect/[...all]"])
      });
    }
  